import { Component, Input } from '@angular/core';
import { statTableConfig } from '../../stats-table/core/stats-table-config';
import { StatLocation } from '../../../../../common/models/statistics/stat-data';
import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FillIfEmptyValuePipe } from '../../../../../common/pipes/fill-if-empty-value.pipe';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { DecimalPipe, NgForOf } from '@angular/common';

@Component({
  selector: 'psc-basic-stat-details',
  templateUrl: './basic-stat-details.component.html',
  standalone: true,
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'admin-pages', alias: 'admin-pages' } }],
  imports: [
    DecimalPipe,
    NgxDatatableModule,
    TranslocoModule,
    NgForOf,
  ],
})
export class BasicStatDetailsComponent {
  @Input() locationData: StatLocation;
  basicColumns = statTableConfig.baseStats;
  protected readonly ColumnMode = ColumnMode;

  constructor(
    public fillIfEmptyValuePipe: FillIfEmptyValuePipe,
  ) {
  }
}
